<template>
    <div id="wrap">

        <MainHeader :hidden="true"/>

        <header class="replboxHead">
            <div class="btn_back" @click="$go(-1)">
              <a class="button" href="javascript:void(0)">
                <span class="sr-only">이전으로 이동</span>
              </a>
            </div>
            <div class="btn_home" @click="$router.push('/main')" @keyup.enter="$router.push('/main')">
              <a class="button" href="javascript:void(0)">
                <span class="sr-only">홈으로 이동</span>
              </a>
            </div>
            <h1>상품 선택<span class="tag" v-if="batch_dlv_yn==='Y'">일괄 배송</span></h1>
            <div class="menu_side">
                <a class="search" @click="$refs.searchMain.openSearch()" href="javascript:void(0)">
                  <span class="sr-only">상품 찾기</span>
                </a>
                <a onclick="window.location.hash = location.hash +'#hamburger'" class="btn_menu" href="javascript:void(0)">
                  <span class="sr-only">나의 메뉴 열기</span>
                </a>
            </div>
        </header>
        <div class="header_sub">

             <div class="select_group_header">
                <div class="selectbox_group">
                    <p class="select_label" @click="changeMenu()"
                                            @keyup.enter="changeMenu()"
                                            aria-label="내 그룹 목록 보기"
                                            role="button"
                                            aria-expanded="false" 
                                            aria-controls="groupContent"
                                            tabindex="0">
                      {{this.selectedGroup.group_nm}} <span class="num">{{this.selectedGroup.cart_cnt}}</span>
                    </p> 
                    <ul class="selectbox_group_ul" id="groupContent" aria-hidden="true">
                          
                            <li v-if="eventDtl.is_update_event_yn === 'Y'" @click="groupModal(true, 'new')"><a class="new_item" href="javascript:void(0)">그룹 추가하기</a></li>
                            <li v-for="(group,i) in groupFiltering" :key="group.group_no" :id="`group_${i}`"  :class="{on:selectedGroup.group_no === group.group_no}" 
                              style="margin-right:15px;">
                                <a  @click="selectGroup(group,i)" href="javascript:void(0)">{{group.group_nm}}
                                <span class="num">{{group.cart_cnt}}</span></a>
                                <i v-if="eventDtl.is_update_event_yn === 'Y'" @click="groupModalUpdate(true, 'update',group, i)" @keyup.enter="groupModalUpdate(true, 'update',group, i)" class="xi-pen" role="button" aria-label="그룹명 수정" tabindex="0"></i>
                                
                            </li>
                        </ul>
                    </div>
                    <li class="toggle_wrap">
                            <span class="txt"><i class="xi-help" @click="help()" @keyup.enter="help()" role="button" aria-label='일괄배송 안내' tabindex="0"></i>일괄 배송</span>
                            <label class="toggle_switch">
                              <input type="checkbox" id="chkBatch_dlv_yn" v-model="batch_dlv_yn" true-value="Y" false-value="N" @change="changeBatchDlvYn()" :disabled="eventDtl.is_update_event_yn === 'N'" aria-label="일괄 배송">
                              <p class="slider"></p>
                            </label>
                    </li>   
            </div>
            
            <div style="position:relative ;display: flex; border-bottom:1px solid #dfdfdf; z-index: 4; background-color:white">
                <ul class="list_header_product" ref="product_scroll">
                    <li v-for="(category) in goodsCategory" :key="category.disp_ctg_no" :id="`category_${category.disp_ctg_no}`" 
                    :class="{on: event_divi_cd === category.disp_ctg_no }" 
                    :ref="`category_${category.disp_ctg_no}`"
                    @click="changeProduct(category, 0)" style="margin-right:15px;"><a href="javascript:void(0)">{{category.disp_ctg_nm}}</a>
                    </li>
                </ul>
                <button class="btn_toggle">메뉴</button>
            </div>

            <!--전체메뉴 11.03 수정-->
            <div class="navi_bg" aria-hidden="true" style="display:none;">
                <div class="navigation-list">
                    <h2>REPLBOX</h2>
                    <dl class="tag-box">
                        <dt>
                            <p>REPLBOX</p>
                        </dt>
                        <dd>
                            <a v-for="category in planList" :key="category.disp_ctg_no"
                            :class="{menu_tag: event_divi_cd === category.disp_ctg_no }"
                            @click="changeProduct(category, 0)" href="javascript:void(0)">{{category.disp_ctg_nm}}</a>
                        </dd>
                    </dl>
                    
                    <h2>시즌 기획전</h2>
                    <dl class="tag-box">
                        <dt>
                            <p>시즌 기획전</p>
                        </dt>
                        <dd>
                            <a v-for="category in bannerList" :key="category.disp_ctg_no"
                            :class="{menu_tag: event_divi_cd === category.disp_ctg_no }"
                            @click="changeProduct(category, 0)" href="javascript:void(0)">{{category.disp_ctg_nm}}</a>
                        </dd>
                    </dl>


                    <h2>상황별 추천</h2>
                    <dl class="tag-box">
                        <dt>
                            <p>상황별 추천</p>
                        </dt>
                        <dd>
                            <a v-for="category in categoryList" :key="category.disp_ctg_no"
                            :class="{menu_tag: event_divi_cd === category.disp_ctg_no }"
                            @click="changeProduct(category, 0)" href="javascript:void(0)">{{category.disp_ctg_nm}}</a>
                        </dd>
                    </dl>
                    
                    <div class="btn_toggle_close" tabindex="0" role="button">
                      <img src="@/assets/images/menu_close.png" alt="닫기버튼">
                    </div>

                </div>
                <div class="dimmed"></div>
            </div>
            
            <ul class="filter_price product">
                <li v-for="price in priceFilterList" :key="price.disp_ctg_nm"
                    :class="{on:selectedPriceFilter.min === price.min && selectedPriceFilter.max === price.max}"
                    @click="selectedPriceFilter = price" ><a href="javascript:void(0)">{{price.disp_ctg_nm}}</a></li>
            </ul>
        
        </div>
        
        <section class="select_product">
            
                
            <!-- 검색결과 -->
            <div v-if="event_divi_cd === search && ((!loading) || (!search_new))" class="product_srch_result" style="padding:20px 0 0;">
                <h6><span class="caption">'{{params.searchTerm}}'</span> 검색결과</h6>
                <p><span class="caption">{{searchGoodsLength + searchGishowGoodsLength}}개</span> 상품이 검색되었습니다.</p>

                <ul class="list_header_product" style="text-align:center; font-size: 15px; border: none;">
                    
                    <li @click="changeSearchType($store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL'])"
                        :class="{on:params.searchType === $store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL']}"> <a>상품 ({{searchGoodsLength}})</a>
                    </li>

                    <li @click="changeSearchType($store.getters['systemStore/PV_GOOD_TYPE_CD_GIFTISHOW'])" 
                        :class="{on:params.searchType === $store.getters['systemStore/PV_GOOD_TYPE_CD_GIFTISHOW']}"> <a>기프티쇼 ({{searchGishowGoodsLength}})</a>
                    </li>

                </ul>
            </div> 

            <div class="product_list_wrap">
                <ul class="product_list" v-if="goodsFiltering.length > 0">
                    <li v-for="(goods) in goodsFiltering" :key="goods.good_no" @click="selectedGoods = goods">
                        <div :class="{'product_list_box': true, 'active': goods.sel_yn === 'Y'}" :id="goods.good_no">
                            <a @click="$refs.goodDtl.searchGood($route.params.event_no, goods.good_no, goods.ord_qty, batch_dlv_yn)" href="javascript:void(0)">
                                <div class="thumb">
                                    <img :src="$store.getters['systemStore/getImgPath']+goods.img_path" :alt="goods.good_nm">
                                    <div v-if="goods.new_good_yn==='Y'" class="thumb_tag">NEW</div>
                                    <div v-if="goods.good_type_cd===$store.getters['systemStore/PV_GOOD_TYPE_CD_GIFTISHOW']" class="thumb_tag_gishow"/>
                                </div>
                                <div class="info" v-if="batch_dlv_yn == 'Y'">
                                    <p>{{goods.good_nm}}</p>
                                    <strong><em>{{goods.sale_price.toLocaleString()}}</em>원</strong>
                                </div>
                                <div class="info" v-else  @click.stop="addCart(goods)">
                                    <p>{{goods.good_nm}}</p>
                                    <strong><em>{{goods.sale_price.toLocaleString()}}</em>원</strong>
                                </div>

                            </a>
                            <!-- <div v-if="batch_dlv_yn == 'N'" class="cart" @click="addCart(goods)"></div> -->
                            <div class="input-form-checkbox" v-if="batch_dlv_yn === 'N'">
                                <input type="checkbox" :id="'check'+goods.good_no"  v-model="goods.sel_yn" true-value="Y" false-value="N" @click="addCart(goods, null, 'checkbox')" :disabled="eventDtl.is_update_event_yn ==='N' " :aria-label="goods.good_nm + ' 상품 선택'">
                                <label :for="'check'+goods.good_no"><i class="xi-check-min" ></i></label>
                            </div>
                            <div v-else>
                                <div class="product_count">
                                    <button class="minus" @click="addCart(goods, goods.ord_qty-1)" :disabled="goods.ord_qty===0  " >
                                      <span class="sr-only">수량 빼기</span>
                                      <i class="xi-minus-min"></i>
                                    </button>
                                    <input type="number" class="num" v-model="goods.ord_qty" @input="checkQty(goods)" min="0" @change="checkQty(goods)" style="width:28px;" aria-label="수량">
                                    <button class="plus" @click="addCart(goods, goods.ord_qty+1)" >
                                      <span class="sr-only">수량 더하기</span>
                                      <i class="xi-plus-min"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-else-if="event_divi_cd === search && goodsFiltering.length === 0 && !loading">
                    <img src="@/assets/images/empty_search.jpg" style="margin: 100px 0px 150px;">
                </ul>

                <infinite-loading v-if="limit > 0" @infinite="infiniteHandler" spinner="waveDots" :identifier="infiniteId" :distance="3000">
                    <div slot="no-more" style="color: rgb(102, 102, 102); font-size: 14px; padding: 10px 0px;"></div>
                </infinite-loading>
            </div>
            <Footer/>
        </section>
        <button class="top_btn">top</button>
        <button class="content_btn" @click="finishSelectGoods()" >{{this.eventDtl.is_update_event_yn ==='N'  ? '다 음' : '선 택 완 료'}}</button>
        <GoodDtl ref="goodDtl" :price_hidden="false" @addcart="emitAddCard"/>



    <!--  S: 팝업_그룹 추가-->
        <div :class="{'popup group':true, active: groupDivi1}" aria-hidden="true" tabindex="-1">
            <div class="popup_container">
                <header class="popup_header">그룹 {{groupDivi2 === 'new' ? '추가' : '수정'}}</header>
                <div class="popup_content">
                    <div class="input_container">
                        <p>그룹명</p>
                        <input type="text" v-model="popupGroup.group_nm" maxlength="30" :readonly="popupGroup.scene_group === 'Y'" aria-label="그룹명 입력">
                    </div>
     
                    
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="crudGroup(groupDivi2)">{{groupDivi2 === 'new' ? '추가' : '수정'}}</button>
                    <button class="btn_large" v-if="groupDivi2 === 'update'" @click="crudGroup('delete')">삭제</button>
                    <button class="btn_large" @click="groupModal(false)">닫기</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        <!--  E: 팝업_그룹 추가-->




        <!-- alert -->
        <div class="popup disp_goods_01" tabindex="-1" aria-hidden="true">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="closeAlertModal('disp_goods_01')">확인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        <Progress :active="progressActive"/>

        <SearchMain ref="searchMain" next="search" @searchGoods="emitSearchGoods"/>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import GoodDtl from '@/components/GoodDtl.vue'
//import EventProgress from '@/components/EventProgress'
import Progress from '@/components/Progress1'
import {api} from '@/api/index.js'
import Footer from '@/components/MainFooter'
// import EventBus from '@/service/EventBus.js'
import _ from "lodash"
import InfiniteLoading from 'vue-infinite-loading'
 
import SearchMain from '@/components/search/SearchMain' //검색화면

 
const MY_CART = "00";
const ALL_GOODS = "0025585864"; //전체,, 리플박스 카테고리 번호 (리플박스 상품 대 카테고리)
const SEARCH = "SEARCH";
const ROWS_PER_PAGE = "100";

export default {
    name: 'DispGoods',
    data() {
        return {
            my_cart : MY_CART,
            search : SEARCH,
            
            bannerList:[],
            categoryList:[],
            planList:[],

            //검색관련
            loading : false,
            infiniteId: +new Date(),
            limit: 0,
            search_new : true,
            searchGoodsLength: 0,
            searchGishowGoodsLength: 0,
            searchGoodList: [],
            searchGiShowList: [],

            goodsList: [],

            priceFilterList : [ {disp_ctg_nm: '전체금액', min: 0, max: null}],

            selectedPriceFilter : {},
            progressActive: false,
            prevRoute: null,
            eventDtl: {},
            step: '',
            alertMsg: '',
            batch_dlv_yn: 'N',
            event_divi_cd:  '',
            groupList: [{batch_dlv_yn:'N'}],
            
            // 그룹리스트 추가 
            groupNmStr: '',
            interval: false,
            
            selectedGroup: {},

            groupDivi1: false, //팝업 active 여부
            groupDivi2: '', //추가, 삭제
            groupDivi4: '', //추가, 삭제
            popupGroup: { group_nm: '', batch_dlv_yn: 'N', cart_cnt: 0 }, //팝업용 그룹

            goodsCategory:[ {disp_ctg_no : MY_CART, disp_ctg_nm: '내가 선택한 상품'},
                            {disp_ctg_no : ALL_GOODS, disp_ctg_nm: '전체상품'}],
            
            params: {
                shop_disp_type_cd_list: ["10"],
                event_no: this.$route.params.event_no,
                group_index: 0,
                group_no: '',
                event_cd: '',
                searchTerm: this.$route.query.searchTerm,
                searchType: this.$store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL'] //10: 일반상품, 80:기프티쇼
            },

            selectedGoods: {},
            groupMenu  : "yes"   // 그룹 메뉴 액션                     
        }
    },
    methods: {
        help() {
            this.fnAlert('※ 한 곳으로 받고 싶을 때※ <br/>' +'① 상품 선택 및 수량 입력<br/>' + '② 다음 단계에서 일괄 배송 받으실 주소 입력');
        },
        emitSearchGoods(searchTerm) {
            // console.log(searchTerm);
            this.params.searchTerm = searchTerm;
            this.$nextTick(()=>{
                this.event_divi_cd = SEARCH
                this.search_new = true;
            })
            
            this.changeProduct(null, 0)
            // this.searchGoodsList();
        },
        fnAlert(msg) {
            this.alertMsg = msg;
            $('.disp_goods_01').addClass('active');

            window.setTimeout(function(){
              $('.disp_goods_01').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
            },100)
        },
          

        // 카테고리 클릭시 이벤트 
        changeProduct(category, price_index){
            $(".btn_toggle_close").click();
            
            if(category != null) {
                this.event_divi_cd = category.disp_ctg_no;
                
                this.$nextTick(()=>{
                    const productScroll1 = this.$refs.product_scroll;
                    let _category = this.$refs[`category_${category.disp_ctg_no}`];
                    productScroll1.scrollTo({ left: _category[0].offsetLeft - window.innerWidth/2.3333333, behavior: 'smooth' });

                })
            }

            this.selectedPriceFilter = this.priceFilterList[price_index];
            this.params.searchType = this.$store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL'];
            this.goodsList = [];
            this.infiniteId += 1;
            this.limit = 1;
        },
        changeSearchType(good_type_cd) {
            this.params.searchType = good_type_cd;

            this.search_new = false;

            if(good_type_cd === this.$store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL']) {
                this.goodsList = this.searchGoodList;
            }
            else {
                this.goodsList = this.searchGiShowList;
            }
            
            this.infiniteId += 1;   // 인피니트 로딩 state가 complete 상태일 수 있으니,,, ready 상태로 변경

        },
        // 셀렉트박스 컨트롤         
        async changeMenu(){
            if(this.groupMenu === "yes"){
                $(".selectbox_group_ul").css({display:""});
                $(".selectbox_group").addClass("on");
                $(".select_label").attr('aria-expanded', 'true')
                $("#groupContent").attr('aria-hidden', 'false')
                this.groupMenu = "no";

            }else{
                $(".selectbox_group_ul").css({display:"none"});
                $(".selectbox_group").removeClass("on");
                $(".select_label").attr('aria-expanded', 'false')
                $("#groupContent").attr('aria-hidden', 'true')
                this.groupMenu = "yes";
            }
        },

        //batch_dlv_yn 변경
        async changeBatchDlvYn() {

            let params = {event_no: this.eventDtl.event_no
                            ,init_batch_dlv_yn: this.batch_dlv_yn}

            await api.postAsync('/event/updateEvent.do', params)
            .then(async data=> {

                if(data.code === 'S') {
                    for (let group of this.groupList) {
                        group.batch_dlv_yn = this.batch_dlv_yn
                        this.$delete(group, 'recvr_no');
                        
                        await api.postAsync('/group/updateGroup.do', group)
                        
                    
                }
            }
        })

        },
        
        //카트에 담겨있는 그룹만 상품 전체 삭제 및 해당 상품만 추가
        cartDelete(){
            for(let cart of this.cartList) { 
                cart.cartGoodsStr = ""; 
            }
            for(let group of this.groupList) { 
                group.cart_cnt = 0;     
            }
            this.selectGroup(this.groupFiltering[0],  0);
        } , 

        //그룹팝업 셋팅
        groupModal(divi1, divi2) {
            // console.log(this.selectedGroup);
            //if(divi2==='new'){

            //    this.fnAlert('그룹 추가 생성 기능은 조만간 업데이트 예정입니다. 이용에 불편을 드려 죄송합니다');
            //    return;

            //}else{
                if(divi1) {
                    this.groupDivi2 = divi2;

                    if(divi2 === 'update') {
                        this.popupGroup = _.cloneDeep(this.selectedGroup);
                    }

                    this.groupDivi1 = divi1

                    window.setTimeout(function(){
                      $('.popup.group').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
                    },100)
                }
                else {
                    this.popupGroup = {group_nm:'', batch_dlv_yn: 'N'};
                    this.groupDivi1 = false;

                    $('.popup.group').attr({'tabindex':-1, 'aria-hidden':'true'});
                }
            //}

        },

          //그룹팝업 수정
        groupModalUpdate(divi1, divi2, divi3, divi4 ) {
             
             
            if(divi1) {
                this.groupDivi2 = divi2;

                if(divi2 === 'update') {
                    this.popupGroup = _.cloneDeep(divi3);
                    this.groupDivi4 = divi4;
                }

                this.groupDivi1 = divi1

                window.setTimeout(function(){
                  $('.popup.group').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
                },100)
                
            }
            else {
                this.popupGroup = {group_nm:'', batch_dlv_yn: 'N'};
                this.groupDivi1 = false;

                $('.popup.group').attr({'tabindex':-1, 'aria-hidden':'true'});
            }
            

        },


        //그룹명 롱클릭 관련
        start(group){
            let time = 0;

            if(!this.interval){
                this.interval = setInterval(() =>{
                    time++;
                        
                    if(time === 1 ) {
                        this.selectedGroup = group;
                        this.popupGroup = group;
                        this.groupModal(true,'update')
                        this.stop();
                    }

                }, 500);
            }
        },
        stop() {
            clearInterval(this.interval)
            this.interval = false
        },


        //******그룹관련******//

        //그룹선택
        selectGroup(group,i) {
            
            let price_index = 0;

            this.event_divi_cd = this.params.event_cd;
            
            this.selectedGroup = group;
            this.selectedGroupList =  i ;
            
            this.params.group_no = group.group_no;

            
            if(group.cart_cnt > 0) {
                this.event_divi_cd = MY_CART;
            }
            else if(this.event_divi_cd === "0025578763" || this.event_divi_cd === "0025578766" || this.event_divi_cd === "0025578765") { // 가격별 카테고리
                this.event_divi_cd = ALL_GOODS;
                for(let i in this.priceFilterList) {

                    let price = this.priceFilterList[i];
                    
                    if(price.disp_ctg_no != undefined && price.disp_ctg_no === this.params.event_cd) {
                        price_index = i;
                        break;
                    }
                }
            }


            for(let i in this.goodsCategory) {
                let category = this.goodsCategory[i];
                if(this.event_divi_cd === SEARCH) {
                    this.changeProduct(null, price_index);
                    break;
                }
                else if (category.disp_ctg_no === this.event_divi_cd) {
                    this.changeProduct(category, price_index);
                    break;
                }
            }
            
            this.changeMenu();
            
        },

        //그룹 추가, 수정, 삭제
        async crudGroup(divi) {

            //추가
            if(divi === 'new') {
                     
                if (2 > this.popupGroup.group_nm.length  || this.popupGroup.group_nm.length > 8) {
                    this.fnAlert('2자 이상 8자 이하로 입력하세요.');
                    window.setTimeout(function(){
                      $('.disp_goods_01').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
                    },100)
                    
                    return;
                }
                
               if(this.groupNmStr.indexOf(this.popupGroup.group_nm.replace(/ /gi,"")+";") > -1) {                
                    this.fnAlert('이미 존재하는 그룹입니다.');
                    window.setTimeout(function(){
                      $('.disp_goods_01').attr({'tabindex':0, 'aria-hidden':'false'}).focus();
                    },100)
                    return;
                }
                else {
                    this.groupNmStr = this.groupNmStr + this.popupGroup.group_nm.replace(/ /gi,"") + ";";
                    this.popupGroup.event_no = this.$route.params.event_no;
                    this.popupGroup.group_no = this.groupList[this.groupList.length-1].group_no*1 + 1;
                    

                    if(this.selectedGroup.batch_dlv_yn === 'Y') {
                        this.popupGroup.batch_dlv_yn = 'Y';
                        this.popupGroup.recvr_cnt = 1;
                        this.popupGroup.cart_cnt = 0;
                    }
                    else {
                        this.popupGroup.recvr_cnt = 0;
                        this.popupGroup.cart_cnt = 0;
                    }
                    //console.log(this.groupList);
                    
                    this.groupList.push(this.popupGroup);
                    this.totRecvrCnt = this.totRecvrCnt +1;
                    //console.log(this.groupList);                     
                    this.selectGroup(this.popupGroup, this.totRecvrCnt -1 );
                    // console.log(this.popupGroup)
                await api.postAsync('/group/addGroupAndGoods.do', this.popupGroup);
                }

            }
            //수정
            else if(divi === 'update') {
           
                if (2 > this.popupGroup.group_nm.length  || this.popupGroup.group_nm.length > 8) {
                    this.fnAlert('2자 이상 8자 이하로 입력하세요.');
                    return;
                }   

                if(this.groupNmStr.indexOf(this.popupGroup.group_nm.replace(/ /gi,"")+";") > -1 && this.popupGroup.group_nm != this.selectedGroup.group_nm) {                
                    this.fnAlert('이미 존재하는 그룹입니다.');
                    return;
                }
                else {
                    
                    //this.selectedGroup = this.popupGroup;
                    
                    this.groupNmStr = this.groupNmStr.replace(this.selectedGroup.group_nm.replace(/ /gi,"")+";","")    
                    this.groupNmStr = this.groupNmStr + this.popupGroup.group_nm.replace(/ /gi,"") + ";";
                    
                    if(this.selectedGroup.batch_dlv_yn === 'N' && this.popupGroup.batch_dlv_yn === 'Y') {
                        this.popupGroup.recvr_cnt = 1;
                        // this.$set(this.selectedGroup, 'recvr_cnt', 1);
                        
                    }
                    else if(this.selectedGroup.batch_dlv_yn === 'Y' && this.popupGroup.batch_dlv_yn === 'N'){
                        this.popupGroup.recvr_cnt = 0;
                        
                    }
                    else if(this.selectedGroup.batch_dlv_yn === this.popupGroup.batch_dlv_yn) {
                        this.popupGroup.recvr_cnt = this.selectedGroup.recvr_cnt*1;

                        
                    }

                    //this.$set(this.selectedGroup, 'group_nm', this.popupGroup.group_nm);
                    //this.$set(this.selectedGroup, 'batch_dlv_yn', this.popupGroup.batch_dlv_yn);
                    //this.$set(this.selectedGroup, 'recvr_cnt', this.popupGroup.recvr_cnt);
                    
                    this.$set(this.groupFiltering[this.groupDivi4], 'group_nm', this.popupGroup.group_nm);
                    this.$set(this.groupFiltering[this.groupDivi4], 'batch_dlv_yn', this.popupGroup.batch_dlv_yn);
                    this.$set(this.groupFiltering[this.groupDivi4], 'recvr_cnt', this.popupGroup.recvr_cnt);
                    // console.log(this.groupFiltering);

                    await api.postAsync('/group/updateGroup.do', this.selectedGroup);

 
                }
          
                
            }
            //삭제
            else if(divi === 'delete') {
                if(this.groupFiltering.length === 1) {
                    this.fnAlert('최소 한개 이상의 그룹이 존재해야 합니다.');
                }
                else {
                    if(confirm('설정된 상품이 초기화 됩니다. 삭제하시겠습니까?')) {

                        this.selectedGroup = this.popupGroup;
                        this.$set(this.selectedGroup, 'deleted', 'Y');
                        
                        this.groupNmStr=this.groupNmStr.replace(this.popupGroup.group_nm.replace(/ /gi,"")+";","");
                 
                        this.$delete(this.groupList, this.groupDivi4 );
                        
                        //console.log(this.cartList);
                        await api.postAsync('/group/deleteGroup.do', this.selectedGroup);
                        
                        this.totRecvrCnt = this.totRecvrCnt -1;  //토탈 그룹수
                        this.selectGroup(this.groupFiltering[0],  0);

                        //this.selectGroup(this.groupFiltering[this.groupFiltering.length-1],  this.totRecvrCnt );
                    }
                }

                // this.changeMenu();
                
            }
            
            this.groupModal(false);
        },

          
        emitAddCard(qty) {
            if(this.batch_dlv_yn === 'N') {
                this.addCart(this.selectedGoods);
            }
            else if(this.batch_dlv_yn === 'Y') {
                this.checkQty(this.selectedGoods, qty);
            }
            
        },
        
        checkQty(goods, qty) {
            if(qty != null && qty != undefined) {
                goods.ord_qty = qty;
            }

            if(goods.ord_qty < 0) {
                this.alertMsg = '0개 보다 작을 수 없습니다.';
                $('.disp_goods_01').addClass('active');
                goods.ord_qty = 0;
            }
            let tempQty = goods.ord_qty*1;
            goods.ord_qty = 0;
            this.addCart(goods, tempQty)
        },

        async infiniteHandler($state) {
            this.loading = true;
            let url = "";
            let rtn_obj_name="";


            let params = {event_no : this.$route.params.event_no,
                          group_no : this.selectedGroup.group_no,
                          disp_ctg_no : this.event_divi_cd,
                          page_idx: `${this.limit}`,
                          rows_per_page: ROWS_PER_PAGE};        
            
            if (this.event_divi_cd === MY_CART) {
                url = "/cart/getCartList.do"
                rtn_obj_name = "cartList";
            }
            else if(this.event_divi_cd === ALL_GOODS || this.event_divi_cd === SEARCH) {
                // this.searchGoodsList();
                // return;
                url = "/search/searchList.do"
                rtn_obj_name = "searchGoodList";

                if(this.params.searchType === this.$store.getters['systemStore/PV_GOOD_TYPE_CD_GIFTISHOW']) {
                    rtn_obj_name = "searchGiShowList";
                }

                if(this.event_divi_cd === SEARCH) {
                    params.disp_ctg_no = null;
                    params.searchTerm = this.params.searchTerm;
                }
                
            }
            else {
                url = "/goods/getGoodsList.do"
                rtn_obj_name = "goodsList";
            }


            // console.log("this.event_divi_cd >>>>>>>>>" + this.event_divi_cd);

            // console.log("params.page_idx >>>>>>>>>" + params.page_idx);

            await api.postAsync(url, params)
                    .then(data=> {
        // console.log(data);
                        let dataLength = 0;

                        if(params.page_idx === "1") {
                            // this.searchList = [];
                            this.goodsList = [];
                            this.searchGoodList = [];
                            this.searchGiShowList = [];
                        }

                        if(data[rtn_obj_name] != null) {
                            dataLength = data[rtn_obj_name].length;
                        }

                        if(this.event_divi_cd === ALL_GOODS || this.event_divi_cd === SEARCH) {

                            data.searchGoodList = data.searchGoodList ?? [];
                            data.searchGiShowList = data.searchGiShowList ?? [];

                            this.searchGoodList = this.searchGoodList.concat(data.searchGoodList);
                            this.searchGiShowList = this.searchGiShowList.concat(data.searchGiShowList);
                            
                            this.searchGoodsLength = data.goodsTotalSize;
                            this.searchGishowGoodsLength = data.gishowGoodsTotalSize;

                            if(this.params.searchType === this.$store.getters['systemStore/PV_GOOD_TYPE_CD_NORMAL']) {
                                dataLength = data.goodsTotalSize;
                            }
                            else {
                                dataLength = data.gishowGoodsTotalSize;
                            }
                        }

                        

                        if(dataLength > 0) {
                            this.goodsList = this.goodsList.concat(data[rtn_obj_name]);
                            
                            
                            $state.loaded();
                            // console.log("after", this.topicData.length, this.limit)
                            // 끝 지정(No more data) - 데이터가 EACH_LEN개 미만이면 

                            if((this.event_divi_cd === ALL_GOODS || this.event_divi_cd === SEARCH) && ((dataLength/ROWS_PER_PAGE) / params.page_idx < 1)) {
                                $state.complete();
                            }
                            else if((this.event_divi_cd != ALL_GOODS && this.event_divi_cd != SEARCH) && (dataLength / ROWS_PER_PAGE < 1)) {
                                $state.complete();
                            }

                        
                            this.limit += 1
                        } 
                        else {
                            // 끝 지정(No more data)
                            // if(params.page_idx > 0) {
                            //     $state.complete();
                            // }
                            // else {
                            //    this.limit += 1
                            //    $state.loaded() ;
                            // }

                            $state.complete();
                            
                        }


                    })

            this.$nextTick(()=>{
                // console.log(this.goodsList);
                this.loading = false;
                this.search_new = false;
            });

        },

        async addCart(goods, qty, divi) {
            if(this.eventDtl.is_update_event_yn === 'N' ){
                alert("결제하신 선물건은 변경하실 수 없습니다.");
            }else{

                let temp_sel_yn = goods.sel_yn + "";
                if (this.batch_dlv_yn === 'N') {
                    if(goods.sel_yn === 'N') {
                        qty = 1;
                    }
                    else {
                        qty = 0;
                    }
                }

                let params = {event_no : this.eventDtl.event_no,
                            good:goods,
                            qty:qty, divi:divi,
                            group_no: this.selectedGroup.group_no};
                

                // console.log(params)
                await api.postAsync('/cart/updateCart.do', params)
                    .then(data=> {
                        // console.log(data)
                        if(data.ret_code === "S") {
                            
                            goods.ord_qty = qty;

                        }
                        else {
                            this.fnAlert(data.ret_msg);
                            if(divi === "checkbox") {
                                this.$nextTick(()=> {
                                    goods.sel_yn = 'N';
                                    goods.ord_qty = 0;
                                });
                            }
                        }
                    })

                            this.$nextTick(()=> {
                                // console.log(temp_sel_yn, goods.ord_qty)
                                    if(temp_sel_yn === "N") {
                                        if(goods.ord_qty > 0) {
                                            this.selectedGroup.cart_cnt += 1;
                                        goods.sel_yn = 'Y';
                                        }
                                    }
                                    else {
                                        if(goods.ord_qty < 1) {
                                            this.selectedGroup.cart_cnt -= 1;
                                        this.$set(goods,'sel_yn', 'N');
                                        }
                                    }


                                    if(this.selectedGroup.cart_cnt > 30) {
                                this.alertMsg = '한 그룹의 최대 상품 개수는 30개 입니다.';
                                $('.disp_goods_01').addClass('active');
                                if((this.selectedGroup.batch_dlv_yn === 'Y') ) {
                                    this.addCart(goods, 0);    
                                    
                                }
                                else {this.addCart(goods);
                                    
                                }
                            }


                            });
                

            }
        },
        async finishSelectGoods() {
            if(this.eventDtl.is_update_event_yn === 'Y') {
                let passStep = true;
                for(let group of this.groupList) {
                    if(group.cart_cnt === 0){
                        this.alertMsg = '상품이 선택되지 않은 그룹이 있습니다.\n최소 1개 이상의 상품을 선택해 주세요.';
                        $('.disp_goods_01').addClass('active');
                        passStep = false;
                        break;
                    }
                    else if(group.cart_cnt > 30) {
                        this.alertMsg = '한 그룹의 최대 상품 개수는 30개 입니다.';
                        $('.disp_goods_01').addClass('active');
                        passStep = false;
                        break;
                    }
                }

                if(passStep) {
                    this.progressActive = true;

                    // console.log(this.batch_dlv_yn)
                    if(this.step < '04') {
                        await api.postAsync('/event/updateEvent.do',{event_no:this.params.event_no, step_divi_cd:'04'});
                        // console.log('update event')
                    }
                    
                    if(this.batch_dlv_yn === "N") {
                        this.$router.push('syncContact');
                    }
                    else {
                        this.$router.push('selectRecvr');
                    }
                    
                    //}
                    
                }
            }
            else if(this.eventDtl){
                this.$router.push('finalCheck');
            }
        },

        closeAlertModal(type){
          $("." + type).toggleClass("active");
          if( $("." + type).attr('tabindex', '0') ){
            $("." + type).attr('tabindex', '-1')
          }else{
            $("." + type).attr('tabindex', '0')
          }
        
          if( $("." + type).attr('aria-hidden', 'false') ){
            $("." + type).attr('aria-hidden', 'true')
          }else{
            $("." + type).attr('aria-hidden', 'false')
          }

          if( $('.popup.group').hasClass('active') ){
            window.setTimeout(function(){
              $('.popup.group').focus();
            },100)
          }
        }

    },
     computed: {
        groupFiltering() {
            return this.groupList.filter(item=> {
                if(item.deleted != 'Y') {
                    return item;
                }
            })
        },

        goodsFiltering() {

            return this.goodsList.filter(item=> {
                if(item.sale_price >= this.selectedPriceFilter.min) {
                    if(this.selectedPriceFilter.max === null) {
                        return item;
                    }
                    else {
                        if(item.sale_price <= this.selectedPriceFilter.max) {
                            return item;
                        }
                    }
                    
                }
            })
        },
    },

    mounted(){
        this.progressActive = true;
        $(document).ready(function(){
            $(".list_header").width("70%");
            $(".selectbox_group_ul").css({display:"none"});
            

            //top 버튼 11.03
            $('.top_btn').hide();

            //  스크롤 탑 + fadein 효과 
            $('#wrap > section').scroll(function(){
            if(	$('#wrap > section').scrollTop() > 50){	
                $(".top_btn").fadeIn();	
            }
            else{	
                $(".top_btn").fadeOut();	
            }			
            });

            //클릭했을 때 스르륵 올라가도록 애니메이션 효과
            $(".top_btn").click(function(){
                $('#wrap > section').animate({
                    scrollTop:0 
                },400 );
                return false;
            });
            console.log($('.btn_toggle'))
            //전체 카테고리 버튼 11.03
            $('.btn_toggle').click(function(){
                $('.navigation-list').toggleClass('on');
                if( $('.navigation-list').hasClass('on') ){
                  $('.navi_bg').css('display', 'block');
                  $('.navi_bg').attr('aria-hidden', 'false')
                }else{
                  $('.navi_bg').css('display', 'none');
                  $('.navi_bg').attr('aria-hidden', 'true')
                }
                $('.dimmed').toggleClass('on');
            });
            $('.btn_toggle_close').click(function(){
                $('.navigation-list').removeClass('on');
                $('.navi_bg').attr('aria-hidden', 'true')
                $('.dimmed').removeClass('on');
                $('.navi_bg').css('display', 'none');
            });
            $('.btn_toggle_close').keyup(function(key){
              if( key.keyCode == 13 ){
                $('.navigation-list').removeClass('on');
                $('.navi_bg').attr('aria-hidden', 'true')
                $('.dimmed').removeClass('on');
                $('.navi_bg').css('display', 'none');
              }
            });
            $('.dimmed').click(function(){
                $('.navigation-list').removeClass('on');
                $('.navi_bg').attr('aria-hidden', 'true')
                $('.dimmed').removeClass('on');
            });

            //카테고리 선택 11.03
            $(".tag-box dd a").click(function(){
                console.log('aa');
                // $(".tag-box dd a").removeClass("menu_tag");
                // $(this).not(".tag-box dd").addClass("menu_tag");
            });

        });
    },
    async created() {
        

        // await api.postAsync('/goods/getCategoryList.do')
        //     .then(data=> {
        //         this.goodsCategory = data.categoryList;            
        //     });
 
        await api.postAsync('/goods/getEventCd.do', {event_no:this.$route.params.event_no})
            .then(data=> {
                // console.log("created " +data);
                if(data.eventCd != null) {
                    this.params.event_cd = data.eventCd.eventcd;
                    this.event_divi_cd = data.eventCd.eventcd;
                    // console.log("created " + this.event_divi_cd);
                }
                else if(data.eventCd === null && this.params.searchTerm != undefined){
                    this.params.event_cd = SEARCH;
                }                
               
            });

        await api.postAsync('/goods/initDispGoods.do', this.params)
            .then(data=>{

            this.planList = [...this.goodsCategory];

            for(let category of data.eventTypes) {
                if(category.upper_disp_ctg_no === '0025581389') { //가격대 기획전인 경우,, 가격필터에 저장한다.
                    if(!category.resd_keyword2) {
                        category.min = null;
                        category.max = null;
                    }
                    else {
                        let prices = category.resd_keyword2.split(',');
                        category.min = !prices[0] || prices[0] === '' ? null : prices[0].trim()*1;
                        category.max = !prices[1] || prices[1] === '' ? null : prices[1].trim()*1;
                    }
                    
                    this.priceFilterList.push(category);
                    
                    
                }
                else {
                    this.goodsCategory.push(category);
                    
                    if(category.upper_disp_ctg_no === MY_CART || category.upper_disp_ctg_no === ALL_GOODS) {
                        this.planList.push(category);
                    }
                    else if(category.upper_disp_ctg_no === this.$store.getters['systemStore/getEventCdBanner']) {
                        this.bannerList.push(category);
                    }
                    else if(category.upper_disp_ctg_no === this.$store.getters['systemStore/getEventCdCategory']) {
                        this.categoryList.push(category);
                    }
                    else if(category.upper_disp_ctg_no === this.$store.getters['systemStore/getEventCdPlan']) {
                        this.planList.push(category);
                    }

                }
            }
            
            // console.log(this.goodsCategory);
            // console.log(this.priceFilterList);

            this.groupList = data.groupList;
         
            this.eventDtl = data.eventDtl;

            this.init_batch_dlv_yn = this.eventDtl.init_batch_dlv_yn;
            this.batch_dlv_yn = this.init_batch_dlv_yn;
            
            for(let group of this.groupList) {
                this.groupNmStr = this.groupNmStr + group.group_nm.replace(/ /gi,"")  +';';
                
            }
            
            this.selectGroup(this.groupFiltering[0]);

            this.changeMenu();
            
            });
            
            
            this.progressActive = false;

        
    },
    //components: {MainHeader,GoodDtl, EventProgress, Progress,Footer},
    components: {MainHeader,GoodDtl,  Progress,Footer, SearchMain, InfiniteLoading},
    beforeRouteEnter(to, from, next) {
        next(vm => {
             vm.prevRoute = from
        })
    },
    
}
</script>

<style scoped>
.infinite-status-prompt {
    display: none;
}
</style>